export default {"src":"/_next/static/media/disc-wheels.7a2cf558.svg","height":382,"width":556,"blurWidth":0,"blurHeight":0};